import { useFlags } from 'launchdarkly-react-client-sdk';
import { useTranslation } from 'react-i18next';
import { isV2Invoice } from '../../../../helpers/invoices';
import { currencyFormatter } from '../../../../helpers/utils';
import { InvoiceStatusBadge } from '../../../Billing/Invoices';
import DateTime from '../../../DateTime/DateTime';
import { DetailCard } from './InvoiceDetailUtils';

export function InvoiceDetailContainerPayments({ selectedInvoice }) {
  const { paymentsAreProcessingFeesHiddenWhenFamilyIsThePayer } = useFlags();
  const { t } = useTranslation();
  const processingFeeLineItem = selectedInvoice.invoiceItemList?.find((item) => item.processingFees !== undefined);
  const processingFeeAmount = processingFeeLineItem ? processingFeeLineItem.amount : 0;
  const payments = selectedInvoice?.payments?.map((payment, index) => {
    const latestStatusFields = isV2Invoice(selectedInvoice)
      ? {
          status: selectedInvoice.status,
          statusDescription: selectedInvoice.statusDescription,
        }
      : {
          userStatus: selectedInvoice.userStatus,
          userStatusDescription: selectedInvoice.userStatusDescription,
        };
    const paidAmount = payment.paidAmount || 0;
    const displayAmount =
      paymentsAreProcessingFeesHiddenWhenFamilyIsThePayer && processingFeeAmount && paidAmount
        ? paidAmount / 100 - processingFeeAmount
        : paidAmount / 100;
    return (
      <tr key={`payment-${index}`}>
        <td data-testid={`invoice-detail-payment-amount-value-${index}`}>
          {displayAmount && currencyFormatter(displayAmount, { precision: 2 })}
        </td>
        <td data-testid={`invoice-detail-payment-date-value-${index}`}>
          {<DateTime epoch={payment.createdAt} format={'MM/DD/YYYY h:mm A'} />}
        </td>
        <td data-testid={`invoice-detail-payment-status-value-${index}`}>
          <InvoiceStatusBadge
            withTooltip
            invoice={{
              ...payment,
              refundFailedReason: selectedInvoice.refundFailedReason,
              ...(index === selectedInvoice.payments?.length - 1 ? latestStatusFields : {}),
            }}
          />
        </td>
      </tr>
    );
  });

  return (
    <DetailCard title={t('billing.invoiceDetail.payments.title')}>
      <table className="text-left">
        <tbody>
          <tr className="border-b border-gray-100">
            <th data-testid="invoice-detail-payment-amount">{t('billing.invoiceDetail.payments.amountColumn')}</th>
            <th data-testid="invoice-detail-payment-date">{t('billing.invoiceDetail.payments.processDateColumn')}</th>
            <th data-testid="invoice-detail-payment-status">{t('common.status')}</th>
          </tr>

          {payments ? (
            payments
          ) : (
            <tr key={'noPayment'} className="text-center">
              <td colSpan={6} data-testid="invoice-detail-no-payments-made">
                {t('billing.invoiceDetail.payments.emptyMessage')}
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </DetailCard>
  );
}
